import firebase from 'firebase';
const config = {
  apiKey: "AIzaSyCHolkxjO5_4P0lUPkwybLkMA36usIK4gc",
  authDomain: "pizzalaideal.firebaseapp.com",
  databaseURL: "https://pizzalaideal.firebaseio.com",
  projectId: "pizzalaideal",
  storageBucket: "pizzalaideal.appspot.com",
  messagingSenderId: "900490754775",
  appId: "1:900490754775:web:69b43eef4e05e1d5"
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
const settings = {timestampsInSnapshots: true};
firestore.settings(settings);

export default firebase;
